<template>
    <b-row v-if="this.$bus.session.invoice_type !== 'invoice'">
        <b-col class="preview_container receipt">
            <!-- 收據範本圖 -->
            <b-img
                fluid-grow
                src="https://img.shoplineapp.com/media/image_clips/63589035c65a4c00222451f8/original.png?1666748469"
            >
            </b-img>

            <!-- 統編 -->
            <span class="company_name">{{company_name}}</span>
            <span class="company_id_1">{{company_id_1}}</span>
            <span class="company_id_2">{{company_id_2}}</span>
            <span class="company_id_3">{{company_id_3}}</span>
            <span class="company_id_4">{{company_id_4}}</span>
            <span class="company_id_5">{{company_id_5}}</span>
            <span class="company_id_6">{{company_id_6}}</span>
            <span class="company_id_7">{{company_id_7}}</span>
            <span class="company_id_8">{{company_id_8}}</span>

            <!-- 日期 -->
            <span class="year">{{year}}</span>
            <span class="month">{{month}}</span>
            <span class="day">{{day}}</span>

            <!-- 項目 -->
            <span class="item_name">{{item_name}}</span>

            <!-- 數量金額 -->
            <span class="item_total">{{item_total}}</span>


            <!-- 國字金額 --> 
            <span class="wan">{{wan}}</span>
            <span class="chian">{{chian}}</span>
            <span class="bai">{{bai}}</span>
            <span class="shih">{{shih}}</span>
            <span class="yuan">{{yuan}}</span>

            <!-- 印章 -->
            <span class="receiptmark">收據專用章</span>
            <span class="receiptmark_self">小章</span>

            <!-- 浮水印 -->
            <span class="watermark">僅供參考</span>

        </b-col>
    </b-row>

    <b-row v-else>
        <b-col class="preview_container invoice">
            <!-- 發票範本圖 -->
            <b-img
                fluid-grow
                src="https://img.shoplineapp.com/media/image_clips/635a37b1e7b180001c4c3afe/original.jpg"
            >
            </b-img>

            <!-- 發票號碼 -->
            <span class="invoice_id">{{invoice_id}}</span>

            <!-- 統編 -->
            <span class="company_name">{{company_name}}</span>
            <span class="company_id_1">{{company_id_1}}</span>
            <span class="company_id_2">{{company_id_2}}</span>
            <span class="company_id_3">{{company_id_3}}</span>
            <span class="company_id_4">{{company_id_4}}</span>
            <span class="company_id_5">{{company_id_5}}</span>
            <span class="company_id_6">{{company_id_6}}</span>
            <span class="company_id_7">{{company_id_7}}</span>
            <span class="company_id_8">{{company_id_8}}</span>

            <!-- 日期 -->
            <span class="year">{{year}}</span>
            <span class="month">{{month}}</span>
            <span class="day">{{day}}</span>

            <!-- 項目 -->
            <span class="item_name">{{item_name}}</span>

            <!-- 數量金額 -->
            <span class="item_total">{{Math.round(item_total/ 1.05)}}</span>
            <span class="item_total_2">{{Math.round(item_total/ 1.05)}}</span>

            <!-- 打勾勾 -->
            <span class="toggle">V</span>

            <!-- 稅金 -->
            <span class="tax">{{tax}}</span>

            <!-- 加上稅金的總計 -->
            <span class="total">{{item_total}}</span>


            <!-- 國字金額 --> 
            <span class="wan">{{wan}}</span>
            <span class="chian">{{chian}}</span>
            <span class="bai">{{bai}}</span>
            <span class="shih">{{shih}}</span>
            <span class="yuan">{{yuan}}</span>

            <!-- 印章 -->
            <span class="receiptmark">統一發票專用章</span>

            <!-- 浮水印 -->
            <span class="watermark">僅供參考</span>

        </b-col>
    </b-row>

</template>

<script>

export default {
  name: 'ReceiptPreview',
  data: function () {
    return {
        company_name: '耐德科技股份有限公司',
        invoice_id: '',
        company_id_1: '7',
        company_id_2: '0',
        company_id_3: '5',
        company_id_4: '4',
        company_id_5: '9',
        company_id_6: '5',
        company_id_7: '0',
        company_id_8: '0',
        item_name: '服務費',
        year: '',
        month: '',
        day: '',
        item_total: 0,
        tax: 0,

        // 萬
        wan: '',
        // 千
        chian:'',
        // 百
        bai: '',
        // 拾
        shih: '',
        // 元
        yuan:'',

        chinese_integer_mapper: {
            0: '零',
            1: '壹',
            2: '貳',
            3: '參',
            4: '肆',
            5: '伍',
            6: '陸',
            7: '柒',
            8: '捌',
            9: '玖',
        },
        chinese_unit_mapper: [
           '圓' ,"拾", "佰", "仟", "萬",
        ]
    }
  },
  props: {
    receiptType: String,
    receiptData: Object
  }
  ,
  methods: {
    parseNumberToChineseNumber: function(total){
        let that = this
        let wan = parseInt(total / 10000)
        console.log(wan)
        if (wan >= 10) {
            let format_wan = ''
            let wans = wan.toString().split('').reverse()
            wans.forEach(function(text, idx){
                format_wan = that.chinese_integer_mapper[parseInt(text)] + that.chinese_unit_mapper[idx] + format_wan 
            })
            this.wan = format_wan.replace('圓','')
        }
        else {
            this.wan = this.chinese_integer_mapper[parseInt(total / 10000)]
        }
        

        let chian = parseInt((total - wan * 10000 ) / 1000)
        console.log(chian)
        this.chian = this.chinese_integer_mapper[chian]

        let bai = parseInt((total - wan * 10000 - chian * 1000 ) / 100) 
        this.bai = this.chinese_integer_mapper[bai]

        let shih = parseInt((total - wan * 10000 - chian * 1000 - bai * 100 ) / 10)  
        this.shih = this.chinese_integer_mapper[shih]

        let yuan = parseInt((total - wan * 10000 - chian * 1000 - bai * 100 - shih * 10 ) / 1)  
        this.yuan = this.chinese_integer_mapper[yuan]

    },
  },
  computed: {
  },
  created: function () {

  },
  mounted: function() {
    console.log(this.receiptData)

    // 發票才要處理日期
    if (this.receiptData.invoice_date) {
        // 處理日期
        let dates = this.receiptData.invoice_date.split('/')
        if (dates.length === 1) {
            dates = this.receiptData.invoice_date.split('-')
        }
        // console.log(dates)
        let year = (parseInt(dates[0]) - 1911).toString()
        this.year = year
        this.month = dates[1]
        this.day = dates[2]
    }

    if (this.receiptData.invoice_no) {
        this.invoice_id = this.receiptData.invoice_no
    }

    // 處理item服務費金額
    this.item_total = this.receiptData.total
    this.tax = this.receiptData.totalTax

    // 處理金額轉國字
    this.parseNumberToChineseNumber(this.receiptData.total)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.preview_container {
  position: relative;
}
.preview_container > span {
  font-family: DFKai-sb;
  font-family: 標楷體;
  position: absolute;
  font-weight: bold;
  font-size: 20px;
  color: red;
}
.receipt .company_name {
    left: 10%;
    top: 24%;
}
.receipt .company_id_1 {
    right: 35%;
    top: 11.5%;
}
.receipt .company_id_2 {
    right: 30.8%;
    top: 11.5%;
}
.receipt .company_id_3 {
    right: 26.5%;
    top: 11.5%;
}
.receipt .company_id_4 {
    right: 22.5%;
    top: 11.5%;
}
.receipt .company_id_5 {
    right: 18.5%;
    top: 11.5%;
}
.receipt .company_id_6 {
    right: 14.3%;
    top: 11.5%;
}
.receipt .company_id_7 {
    right: 10.2%;
    top: 11.5%;
}
.receipt .company_id_8 {
    right: 6%;
    top: 11.5%;
}
.receipt .item_name {
    left: 6%;
    top: 34%;
    font-size: 16px;
    letter-spacing: 3px;
}
.receipt .year {
    right: 28%;
    top: 19.5%;
    letter-spacing: 3px;
}
.receipt .month {
    right: 18%;
    top: 19.5%;
    letter-spacing: 3px;
}
.receipt .day {
    right: 8%;
    top: 19.5%;
    letter-spacing: 3px;
}

.receipt .item_total {
    right: 36%;
    top: 33.7%;
    letter-spacing: 3px;
    font-size: 18px;
}
.receipt .wan {
    right: 77%;
    bottom: 21%;
    font-size: 17px !important;
}

.receipt .chian {
    right: 67%;
    bottom: 21%;
    font-size: 17px !important;
}

.receipt .bai {
    right: 57%;
    bottom: 21%;
    font-size: 17px !important;
}

.receipt .shih {
    right: 47.5%;
    bottom: 21%;
    font-size: 17px !important;
}

.receipt .yuan {
    right: 37.5%;
    bottom: 21%;
    font-size: 17px !important;
}
.receipt .receiptmark {
    border: 1px red solid;
    right: 12%;
    top: 50%;
    z-index: 10;
    border-radius: 50%;
    font-size: 16px;
    padding:5px;
}

.receipt .receiptmark_self {
    border: 1px red solid;
    right: 6.5%;
    bottom: 19%;
    font-size: 16px;
    padding:5px;
}

/** 發票樣式 */
.invoice .company_name {
    left: 16%;
    top: 13.5%;
}

.invoice .invoice_id {
    left: 4.5%;
    top: 2%;
}

.invoice .company_id_1 {
    left: 17%;
    top: 19%;
}

.invoice .company_id_2 {
    left: 21%;
    top: 19%;
}

.invoice .company_id_3 {
    left: 24.5%;
    top: 19%;
}

.invoice .company_id_4 {
    left: 28%;
    top: 19%;
}

.invoice .company_id_5 {
    left: 31.5%;
    top: 19%;
}
.invoice .company_id_6 {
    left: 35.5%;
    top: 19%;
}
.invoice .company_id_7 {
    left: 39%;
    top: 19%;
}

.invoice .company_id_8 {
    left: 43%;
    top: 19%;
}

.invoice .year {
    right:38%;
    top: 19.5%;
}

.invoice .month {
    right:31%;
    top: 19.5%;
}

.invoice .day {
    right:23.5%;
    top: 19.5%;
}

.invoice .item_name {
    left: 6%;
    top: 37.5%;
    font-size: 18px;
    letter-spacing: 3px;
}

.invoice .item_total {
    right: 32.5%;
    top: 37%;
    font-size: 18px;
}
.invoice .item_total_2 {
    right: 32.5%;
    bottom: 26%;
    font-size: 18px;
}

.invoice .toggle {
    left: 28%;
    bottom: 17%;
    font-size: 18px;
}

.invoice .tax {
    right: 32.5%;
    bottom: 19%;
    font-size: 18px;
}
.invoice .total {
    right: 33%;
    bottom: 12%;
    font-size: 18px;
}

.invoice .receiptmark {
    right: 8%;
    bottom: 23%;
    font-size: 18px;
    border: 1px red solid;
    padding: 5px;
}



.invoice .wan {
    right: 58.2%;
    bottom: 5%;
}

.invoice .chian {
    right: 52.2%;
    bottom: 5%;
}

.invoice .bai {
    right: 46.5%;
    bottom: 5%;
}

.invoice .shih {
    right: 40.3%;
    bottom: 5%;
}

.invoice .yuan {
    right: 34.5%;
    bottom: 5%;
}


/** 浮水印 */
.watermark {
    color: #CCC  !important;
    font-size: 50px !important;
    letter-spacing: 25px;
    opacity: 0.3;
    transform: rotate(340deg)
}
.receipt .watermark {
    left: 32%;
    top: 45%;
}
.invoice .watermark {
    left: 32%;
    top: 45%;
}
</style>
